export const DEFAULT_AUTOCOMPLETE_CLASS_NAME = 'defaultFingoAutocomplete';
export const ONBOARDING_AUTOCOMPLETE_CLASS_NAME = 'onboardingFingoAutocomplete';
